import { Injectable } from '@angular/core';
import { AuthenticationService } from './authentication.service';

@Injectable({
  providedIn: 'root',
  
})
export class InactivityService {
  inactivityTimeout: any;

  constructor(
    private readonly authenticationService :AuthenticationService
  ) { }

  setupInactivityTracking() {
    document.onmousemove = this.resetInactivityTimer.bind(this);
    document.onkeydown = this.resetInactivityTimer.bind(this);
    document.onkeyup = this.resetInactivityTimer.bind(this);
    window.addEventListener('storage', (event) => {
      if (event.key === 'lastActivity') {
        this.resetInactivityTimer();
      }
    });
    this.resetInactivityTimer();
  }

  resetInactivityTimer() {
    clearTimeout(this.inactivityTimeout);
    localStorage.setItem('lastActivity', new Date().toString());
    this.inactivityTimeout = setTimeout(() => {
      this.authenticationService.logout();
      alert("You have been logged out due to inactivity.");
    }, 1800000); 
  }

  checkInactivityOnLoad() {
    const lastActivity = localStorage.getItem('lastActivity');
    if (lastActivity) {
      const inactivityDuration = new Date().getTime() - new Date(lastActivity).getTime();
      if (inactivityDuration > 1800000) {
        this.authenticationService.logout();
        alert("You have been logged out due to inactivity.");
      }
    }
  }
}
